<template>
  <fieldset :disabled="!this.ndxLoaded" class="chart-fieldset">
    <v-layout class="chart-form">
      <v-flex xs6>
        <h4>Water Depth</h4>

        <v-layout>
          <v-flex xs6>
            <label v-for="wd in $options.waterDepths" :key="wd.value">
              <input type="radio" v-model="form.water_depth" :value="wd.value" />
              {{ wd.label }}
            </label>
          </v-flex>

          <!--
          <v-flex xs6>
            <label v-for="wd in $options.waterDepths.slice(3, 5)" :key="wd.value">
              <input type="radio" v-model="form.water_depth" :value="wd.value" />
              {{ wd.label }}
            </label>
          </v-flex>
          -->
        </v-layout>
      </v-flex>

      <v-flex xs3>
        <h4>Period</h4>

        <label v-for="wd in $options.periods" :key="wd.value">
          <input type="radio" v-model="form.period" :value="wd.value" />
          {{ wd.label }}
        </label>
      </v-flex>

      <!--
      <v-flex xs3>
        <h4>Interval</h4>

        <label v-for="wd in $options.intervals" :key="wd.value">
          <input type="radio" v-model="form.interval" :value="wd.value" />
          {{ wd.label }}
        </label>
      </v-flex>
      -->
    </v-layout>
  </fieldset>
</template>

<script>
export default {
  originalData: [],
  waterDepths: [
    { value: '0-Infinity', label: 'All' },
    { value: '0-250', label: '<250m' },
    { value: '250-1000', label: '250-1000m' },
    { value: '1000-2000', label: '1000-2000m' },
    { value: '2000-Infinity', label: '>2000m' },
  ],
  periods: [
    { label: 'by FID', value: 'fid_date' },
    { label: 'by Contract Award', value: 'order_date' }, // value: 'cont_award' },
    { label: 'by Installation', value: 'installation_date' },
  ],
  intervals: [{ label: 'Annual', value: 'Annual' }, { label: 'Quaterly', value: 'Quaterly' }],
  computed: {
    ndxLoaded() {
      return this.$attrs.ndxLoaded;
    },
  },
  watch: {
    ndxLoaded() {
      if (this.ndxLoaded) {
        this.$options.originalData = [...this.$attrs.ndx.all()];
      }
    },
    'form.water_depth': function() {
      this.applyFilters();
    },
    'form.period': function() {
      this.$emit('formChanged', this.form.period);
    },
    'form.interval': function() {
      this.$emit('formChanged', this.form.period);
    },
  },
  data() {
    return { form: { water_depth: '0-Infinity', period: 'fid_date', interval: 'Annual' } };
  },
  methods: {
    applyFilters() {
      let data = [...this.$options.originalData];
      data = this.getWaterDepthData(data);

      this.$attrs.ndx.remove();
      this.$attrs.ndx.add(data);
      dc.redrawAll();
    },
    //
    getWaterDepthData(data) {
      let [min, max] = this.form.water_depth.split('-').map(v => +v);

      return data.filter(v => {
        return v.water_depth >= min && v.water_depth < max;
      });
    },
  },
};
</script>

<style scoped>
.chart-form {
  padding: 10px;
  background: #efefef;
}
label {
  display: block;
  margin-bottom: 5px;
}
.flex {
  position: relative;
}
.chart-form {
  width: 70%;
  border: 1px solid #cfcfcf;
}
.chart-fieldset {
  border: none;
}
</style>
